import { Alert, Badge, Tooltip } from "antd";
import PropTypes from "prop-types";
import CarDetailFieldTable from "../../../cars/components/cardetails/CarDetailFieldTable";
import displayValue from "../../../../utilities/displayValue";

function formatLicenseBirthDate(birthDate) {
    if (!birthDate) return null;
    if (typeof birthDate === "object" && birthDate.$date) {
        return new Date(birthDate.$date).toLocaleDateString();
    }
    return new Date(birthDate).toLocaleDateString();
}

function verificationAlertType(status) {
    if (status === "verified") return "success";
    if (status === "unverified") return "error";
    return "warning";
}

function verificationMessage(status, t) {
    if (status === "verified") return t("customerDetail.licenseVerified");
    if (status === "unverified") return t("customerDetail.licenseNotVerified");
    if (status === "no_applicant_id") return t("customerDetail.noApplicantId");
    if (status === "error") return t("customerDetail.verificationError");
    return t("customerDetail.noVerificationData");
}

function CustomerLicenseSection({
    customer,
    licenseVerificationStatus,
    checkingVerification,
    onRefreshVerification,
    t,
    na,
}) {
    const license = customer?.drivingLicense;

    const licenseRows = [
        { label: t("customerDetail.firstName"), value: license?.firstName },
        { label: t("customerDetail.lastName"), value: license?.lastName },
        {
            label: t("licenseNumber"),
            render: () => (
                <div className="flex items-center justify-between gap-2">
                    <span>{displayValue(license?.number, na)}</span>
                    {licenseVerificationStatus && (
                        <Tooltip title={verificationMessage(licenseVerificationStatus, t)}>
                            <Badge
                                status={
                                    licenseVerificationStatus === "verified"
                                        ? "success"
                                        : licenseVerificationStatus === "unverified"
                                          ? "error"
                                          : "warning"
                                }
                            />
                        </Tooltip>
                    )}
                </div>
            ),
        },
        { label: t("customerDetail.state"), value: license?.state },
        {
            label: t("customerDetail.birthDate"),
            value: formatLicenseBirthDate(license?.birthDate),
        },
    ];

    return (
        <div className="rounded-2xl border border-[#f0f0f0] bg-white p-4">
            {checkingVerification ? (
                <Alert
                    message={`${t("customerDetail.checking")}...`}
                    type="info"
                    showIcon
                    className="mb-4"
                />
            ) : (
                <Alert
                    message={verificationMessage(licenseVerificationStatus, t)}
                    type={verificationAlertType(licenseVerificationStatus)}
                    showIcon
                    className="mb-4"
                    action={
                        customer?.email ? (
                            <Tooltip title={t("customerDetail.refreshVerification")}>
                                <button
                                    type="button"
                                    onClick={onRefreshVerification}
                                    disabled={checkingVerification}
                                    className="rounded border border-[#5d5dff] px-2 py-1 text-xs text-[#5d5dff] transition-colors hover:bg-[#f0f0ff] disabled:cursor-not-allowed disabled:opacity-50">
                                    {t("customerDetail.refresh")}
                                </button>
                            </Tooltip>
                        ) : null
                    }
                />
            )}

            <CarDetailFieldTable title={t("drivingLicense")} rows={licenseRows} naFallback={na} />
        </div>
    );
}

CustomerLicenseSection.propTypes = {
    customer: PropTypes.object,
    licenseVerificationStatus: PropTypes.string,
    checkingVerification: PropTypes.bool,
    onRefreshVerification: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    na: PropTypes.string.isRequired,
};

export default CustomerLicenseSection;
